import { FloatingCardTemplate } from "themes/common/components";

function FloatingCard(props) {
    return <FloatingCardTemplate {...props} />;
}

export default FloatingCard;
